define([
	"dojo/_base/declare",
	"csi/table/ApplySort",
	"csi/xml/Query",
	"SiteAdmin/DataSheetTable",
	"./_ProductAlternativeViewMixin"
], function(declare,ApplySort,Query,DataSheetTable,_ProductAlternativeViewMixin) {

	var _ApplySort = declare(ApplySort, {
		postProcessSuccess: function() {
			this.inherited(arguments);
			this.widget.refreshDataRows();
		}
	});

	return declare([DataSheetTable, _ProductAlternativeViewMixin], {
		_actionControllers: {
			TableApplySort: _ApplySort
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: filter out items that do not apply to selected product alternative
			var	ql = this.inherited(arguments);
			if (ql.bMain) {
				var q = new Query();

				this._addProductAlternativeQuery(q);

				if (!q.isEmpty()) {
					ql.serverQuery = q;
				}
			}

			return ql;
		}
	});
});
